var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ThemeProvider',{attrs:{"theme":_vm.theme}},[_c(this.$route.meta.layout || 'div',{tag:"Component"},[_c('RouterView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }